let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bqlNZ")).then(() => parcelRequire('13mkU'));